import { lexonHttp } from '@/plugins/axios/lexonHttp'

export class CustomerPortalService {
  async customerPortal(customerId: string) {
    return await lexonHttp.get(`/v2/customer-portal/${customerId}`)
  }
  async activate(payload: any) {
    return await lexonHttp.put(`/v2/customer-portal/${payload.id}/activate`, payload)
  }
  async unlok(customerId: string) {
    return await lexonHttp.put(`/v2/customer-portal/${customerId}/unlock`)
  }
  async lock(customerId: string) {
    return await lexonHttp.put(`/v2/customer-portal/${customerId}/lock`)
  }
  async delete(customerId: string) {
    return await lexonHttp.delete(`/v2/customer-portal/${customerId}`)
  }
}
